/**
 * Combine the stats in order to have equal width depending on the column
 * @param {Array} primaryStats This is the array of primary statistics from server
 * @param {Array} secondaryStats This is the array of secondary statistics from server
 @example
 const primaryStats = [1,2,3]
 const secondaryStats = [4,5,6,7,8,9];
 const result = [
 [1, 4],
 [2, 5],
 [3, 6],
 [null, 7],
 [null, 8],
 ]
 */

export default function combineStats(primaryStats, secondaryStats) {
  // 1. get the maximum amongst the both
  // 2. loop through the max and on every iteration get the value of the min stats array
  // 3. if any of the stats array doesn't have a value push null else push its value
  // 4. like [null, 4] or [4, null] or [1, 2]

  const combinedStats = [];
  const totalIteration =
    primaryStats.length > secondaryStats.length ? primaryStats.length : secondaryStats.length;

  for (let i = 0; i < totalIteration; i++) {
    const primaryStatsValue = primaryStats[i] || null;
    const secondaryStatsValue = secondaryStats[i] || null;

    combinedStats.push([primaryStatsValue, secondaryStatsValue]);
  }

  return combinedStats;
}
